import { If } from '@payments-checkout/shared/components';
import { usePaymentMethod } from '@payments-checkout/shared/providers';
import { Text } from '@stone-payments/jade';
import './clickToPay.css';

export const ClickToPayWrapper = ({
  onCloseClick,
}: {
  onCloseClick: () => void;
}) => {
  const { showClickToPay } = usePaymentMethod();

  return (
    <If condition={showClickToPay}>
      <div className="flex flex-col gap-jade-150 bg-jade-background-surface rounded-xl p-jade-250 min-500:p-0 min-500:rounded-none">
        <Text variant="heading-small" color="high">
          Pagar com Click to Pay
        </Text>
        <div id="hst_src" className="clickToPay" style={{ boxSizing: 'border-box' }} />
      </div>
    </If>
  );
};
